const translations = {
  fr: {
    commonRegistration: {
      passwordInvalidMessage: 'Votre mot de passe doit contenir au moins 8 caractères et une majuscule et/ou un chiffre et/ou un caractère special',
      passwordConfirmation: 'Confirmation du mot de passe',
      register: 'S\'inscrire',
      welcomeMessage: 'Bonjour {{name}}, bienvenue chez {{productName}}!',
    },
  },
  en: {
    commonRegistration: {
      passwordInvalidMessage: 'Your password must contain at least 8 characters and an uppercase and / or a number and / or a special character',
      passwordConfirmation: 'Password confirmation',
      register: 'Register',
      welcomeMessage: 'Hello {{name}}, welcome to {{productName}}!',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/common/modules/registration/i18n/commonRegistration.js